import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Util } from '@libs/utilities/util';

import { NgAbstractInputComponent } from '../../shared/inputs.abstract';


@Component({
    selector: 'ng-rgb-color-picker',
    templateUrl: './rgb-color-picker.component.html',
    styleUrls: ['./rgb-color-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: NgRgbColorPickerComponent,
            multi: true
        }
    ],
    standalone: false
})
export class NgRgbColorPickerComponent extends NgAbstractInputComponent<string> implements ControlValueAccessor {

	//** Configuration */
	private readonly DEFAULT_COLOR: string = '#000000';

	//** Helper Variables */
	isDarkColor 		: boolean = false;

	constructor() {
		super('rgb-color-picker');
	}

	override writeValue(value: string): void {

		//0 - updating the color value
		this.value = value || this.DEFAULT_COLOR;
		if (!Util.Color.isHexColor(this.value)) throw new Error(`RgbColorPickerComponent => writeValue => FATAL ERROR: Provided color value of "${this.value}" is not valid color value`);

		// Loading another product must not emit an edit into the current form.
		this.isDarkColor = this.checkIsDarkColor(this.value);
	}

	//** On color change */
	onColorChange(hexCode: string): void {

		//0 - check the color dark or light
		this.value = hexCode;
		this.isDarkColor = this.checkIsDarkColor(hexCode);

		//1 - emit the changed color
		this.onChange(hexCode);
	}


	/**------------------------------------------------------
	 * Helper Function
	 */
	//** Check the color pallet color is dark */
	checkIsDarkColor(colorValue: string): boolean {
		if (!Util.Color.isHexColor(colorValue)) throw new Error(`RgbColorPickerComponent => isDarkColor => FATAL ERROR: Provided color value of "${colorValue}" is not valid color value`);
		return Util.Color.isDark(colorValue);
	}
}
